var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sku-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加属性",
            visible: _vm.skuDialogVisible,
            width: "30%",
            "before-close": _vm.handleClose,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.skuDialogVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            directives: [{ name: "emoji", rawName: "v-emoji" }],
            attrs: { placeholder: "请输入属性名称" },
            model: {
              value: _vm.skuName,
              callback: function ($$v) {
                _vm.skuName = $$v
              },
              expression: "skuName",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.skuDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addSku } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.disabled
        ? _c(
            "div",
            { staticClass: "sku-check" },
            [
              _vm.theme == 1
                ? _c(
                    "div",
                    { staticClass: "theme-1" },
                    [
                      _vm._l(_vm.myAttribute, function (item, index) {
                        return _c(
                          "el-card",
                          {
                            key: index,
                            staticClass: "item",
                            attrs: { shadow: "never" },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "header" }, slot: "header" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "clearfix",
                                    attrs: { slot: "header" },
                                    slot: "header",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { style: { width: "50%" } },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "emoji",
                                              rawName: "v-emoji",
                                            },
                                          ],
                                          attrs: {
                                            placeholder: "请输入属性名称",
                                            size: "small",
                                          },
                                          model: {
                                            value: item.name,
                                            callback: function ($$v) {
                                              _vm.$set(item, "name", $$v)
                                            },
                                            expression: "item.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.canEditSku
                                      ? _c("el-button", {
                                          staticStyle: {
                                            float: "right",
                                            padding: "3px 0",
                                          },
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-delete",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteSku(item, index)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._l(item.item, function (item2, index2) {
                              return _c("el-checkbox", {
                                key: index2,
                                attrs: { label: item2.name, size: "small" },
                                model: {
                                  value: item2.checked,
                                  callback: function ($$v) {
                                    _vm.$set(item2, "checked", $$v)
                                  },
                                  expression: "item2.checked",
                                },
                              })
                            }),
                            item.canAddAttribute
                              ? _c(
                                  "el-input",
                                  {
                                    directives: [
                                      { name: "emoji", rawName: "v-emoji" },
                                    ],
                                    staticClass: "add-attr",
                                    attrs: {
                                      size: "small",
                                      placeholder: "新增一个规格",
                                    },
                                    nativeOn: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.onAddAttribute(index)
                                      },
                                    },
                                    model: {
                                      value: item.addAttribute,
                                      callback: function ($$v) {
                                        _vm.$set(item, "addAttribute", $$v)
                                      },
                                      expression: "item.addAttribute",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "append",
                                          size: "small",
                                          icon: "el-icon-plus",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onAddAttribute(index)
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_vm._v(" 添加 ")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                      _c(
                        "el-card",
                        {
                          staticClass: "item",
                          attrs: {
                            shadow: "never",
                            "body-style": { height: "100%" },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "add-item",
                              on: {
                                click: function ($event) {
                                  _vm.skuDialogVisible = true
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                style: { fontSize: "36px", color: "#409EFF" },
                              }),
                              _c("span", { style: { color: "#409EFF" } }, [
                                _vm._v("添加属性"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : _c(
                    "el-table",
                    {
                      staticClass: "theme-2",
                      attrs: { data: _vm.myAttribute, "show-header": false },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "name", width: "120", resizable: false },
                      }),
                      _c("el-table-column", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _vm._l(
                                  scope.row.item,
                                  function (item2, index2) {
                                    return _c("el-checkbox", {
                                      key: index2,
                                      attrs: {
                                        label: item2.name,
                                        size: "small",
                                      },
                                      model: {
                                        value: item2.checked,
                                        callback: function ($$v) {
                                          _vm.$set(item2, "checked", $$v)
                                        },
                                        expression: "item2.checked",
                                      },
                                    })
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          904863973
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { width: "250" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-input",
                                    {
                                      directives: [
                                        { name: "emoji", rawName: "v-emoji" },
                                      ],
                                      staticClass: "add-attr",
                                      attrs: {
                                        size: "small",
                                        placeholder: "新增一个规格",
                                      },
                                      nativeOn: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.onAddAttribute(
                                            scope.$index
                                          )
                                        },
                                      },
                                      model: {
                                        value: scope.row.addAttribute,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "addAttribute",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.addAttribute",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            slot: "append",
                                            size: "small",
                                            icon: "el-icon-plus",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onAddAttribute(
                                                scope.$index
                                              )
                                            },
                                          },
                                          slot: "append",
                                        },
                                        [_vm._v(" 添加 ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3930100946
                        ),
                      }),
                    ],
                    1
                  ),
            ],
            1
          )
        : _c("div", [_vm._t("Attribute")], 2),
      _c(
        "div",
        { staticClass: "sku-list" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "status-icon": "",
                "inline-message": "",
              },
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.form.skuData,
                    stripe: "",
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _vm.emitAttribute.length > 0
                    ? _c("el-table-column", {
                        attrs: {
                          type: "index",
                          width: "50",
                          align: "center",
                          resizable: false,
                        },
                      })
                    : _vm._e(),
                  _vm._l(_vm.emitAttribute, function (attr, index) {
                    return _c("el-table-column", {
                      key: "attribute-" + index,
                      attrs: {
                        label: attr.name,
                        prop: attr.name,
                        width: "120",
                        align: "center",
                        resizable: false,
                        sortable: "",
                      },
                    })
                  }),
                  _vm._l(_vm.structure, function (item, index) {
                    return _c(
                      "el-table-column",
                      {
                        key: "structure-" + index + "-" + item.name,
                        attrs: {
                          label: item.label,
                          prop: item.name,
                          align: "center",
                          resizable: false,
                          "min-width": "150px",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  item.type == "input"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          key:
                                            "structure-input-" +
                                            index +
                                            "-" +
                                            scope.row.sku,
                                          attrs: {
                                            prop:
                                              "skuData." +
                                              scope.$index +
                                              "." +
                                              item.name,
                                            rules: _vm.rules[item.name],
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            directives: [
                                              {
                                                name: "emoji",
                                                rawName: "v-emoji",
                                              },
                                            ],
                                            attrs: {
                                              placeholder:
                                                "请输入" + item.label,
                                            },
                                            model: {
                                              value: scope.row[item.name],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  item.name,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row[item.name]",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : item.type == "select"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          key:
                                            "structure-input-" +
                                            index +
                                            "-" +
                                            scope.row.sku,
                                          attrs: {
                                            prop:
                                              "skuData." +
                                              scope.$index +
                                              "." +
                                              item.name,
                                            rules: _vm.rules[item.name],
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder:
                                                  "请选择" + item.label,
                                              },
                                              model: {
                                                value: scope.row[item.name],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    item.name,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row[item.name]",
                                              },
                                            },
                                            _vm._l(
                                              item.inputList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item,
                                                  attrs: {
                                                    label: item,
                                                    value: item,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : item.type == "slot"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          key:
                                            "structure-input-" +
                                            index +
                                            "-" +
                                            scope.row.sku,
                                          attrs: {
                                            prop:
                                              "skuData." +
                                              scope.$index +
                                              "." +
                                              item.name,
                                            rules: _vm.rules[item.name],
                                          },
                                        },
                                        [
                                          _vm._t(item.name, null, {
                                            $index: scope.$index,
                                            row: scope.row,
                                            column: scope.column,
                                          }),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "template",
                          { slot: "header" },
                          [
                            _c(
                              "span",
                              { class: { required_title: item.required } },
                              [_vm._v(" " + _vm._s(item.label) + " ")]
                            ),
                            item.tip
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: item.tip,
                                      placement: "top",
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-info" })]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                  !_vm.isEdit
                    ? _c(
                        "el-table-column",
                        {
                          attrs: { label: "操作", width: "50" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "删除本条数据",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            style: { marginRight: "10px" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteSkuItem(
                                                  scope.row,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-delete plus",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            44500271
                          ),
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.addSkuItem },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-folder-add icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.isBatch && _vm.form.skuData.length > 2 && !_vm.disabled
                    ? _c(
                        "template",
                        { slot: "append" },
                        [
                          _c(
                            "el-table",
                            { attrs: { data: [{}], "show-header": false } },
                            [
                              _c(
                                "el-table-column",
                                {
                                  attrs: {
                                    width: _vm.attribute.length * 120 + 50,
                                    align: "center",
                                    resizable: false,
                                  },
                                },
                                [_vm._v(" 批量设置 ")]
                              ),
                              _vm._l(_vm.structure, function (item, index) {
                                return _c(
                                  "el-table-column",
                                  {
                                    key: "batch-structure-" + index,
                                    attrs: {
                                      align: "center",
                                      resizable: false,
                                      "min-width": "120px",
                                    },
                                  },
                                  [
                                    item.type == "input" && item.batch != false
                                      ? _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              "填写一个" + item.label,
                                            size: "small",
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.onBatchSet(item.name)
                                            },
                                          },
                                          model: {
                                            value: _vm.batch[item.name],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.batch,
                                                item.name,
                                                $$v
                                              )
                                            },
                                            expression: "batch[item.name]",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }